import { createContext, type ComponentChildren } from 'preact';
import { useContext, useEffect, useMemo } from 'preact/hooks';
import type { Platform } from '@vibeshell/shared';

const PlatformContext = createContext<Platform>('unknown');

function detectPlatform(): Platform {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'unknown';
}

export function PlatformProvider({ children }: { children: ComponentChildren }) {
  const platform = useMemo<Platform>(() => detectPlatform(), []);
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.body.classList.add(`platform-${platform}`);
    return () => {
      document.body.classList.remove(`platform-${platform}`);
    };
  }, [platform]);
  return <PlatformContext.Provider value={platform}>{children}</PlatformContext.Provider>;
}

export function usePlatform(): Platform {
  return useContext(PlatformContext);
}
